<div class="cost-contribution" [style.opacity]="!isLoading ? '1' : '0.3'">
    <div class="loader" *ngIf="isLoading">
        <div>{{message}}</div>
    </div>
    <h4 class="d-flex">Cost Contribution &nbsp;
        <div *ngIf="level==='factory'" [style.display]="level==='factory' ? '' : 'none'" [popover]="costPopOver"
            triggers="mouseenter:mouseleave" container="body" placement="bottom"><img
                src="../../../assets/images/icn-info.svg" alt=""></div>
        <div *ngIf="level==='line'" [style.display]="level==='line' ? '' : 'none'" [popover]="costPopOver1"
            triggers="mouseenter:mouseleave" container="body" placement="bottom"><img
                src="../../../assets/images/icn-info.svg" alt=""></div>
    </h4>
    <div class="cc-wrapper">
        <div class="cc-selection">
            <mat-radio-group (change)="onChange($event)" class="cc-mat-radio" aria-label="Select an option"
                [disabled]="constContributionFilteredList.length === 0">
                <mat-radio-button class="cc-mat-radio-option" value="Line"
                    [checked]="selectedCostContribution === 'Line'" *ngIf="level === 'factory'">Line</mat-radio-button>
                <mat-radio-button class="cc-mat-radio-option" value="Sku"
                    [checked]="selectedCostContribution === 'Sku'">SKU</mat-radio-button>
                <mat-radio-button class="cc-mat-radio-option" value="Bom"
                    [checked]="selectedCostContribution === 'Bom'">BoM</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="cc-graph-container">
            <div #graphDiv class="donut" id="graphDiv"></div>
            <div class="cc-graph-details">
                <div class="cc-graph-details-title">{{graphHoverTitle}}</div>
                <div class="cc-graph-details-cost" *ngIf="graphHoverCost" innerHTML="{{graphHoverCost | cost}}"></div>
                <div class="cc-graph-details-percentage">{{graphHoverPercentage}}</div>
            </div>
        </div>

        <div class="cc-list" (mouseleave)="setGraphTitle()" *ngIf="constContributionFilteredList.length > 0">
            <div class="cc-item"
                [class.no-cursor]="this.level === 'factory' && this.selectedCostContribution === 'Sku' || this.selectedCostContribution === 'Bom'"
                *ngFor="let item of constContributionFilteredList"
                [popover]="(selectedCostContribution !== 'Line') ? item.id : ''" triggers="mouseenter:mouseleave"
                (mouseover)="setGraphTitle(item)" (click)="onClickCostContribution(item)" (focus)="setGraphTitle(item)"
                (keydown.enter)="onClickCostContribution(item)" (keydown.space)="onClickCostContribution(item)">
                <div class="cc-left">
                    <div class="cc-color" [style.background-color]="item.color"></div>
                    <div class="cc-name">
                        {{ (item?.name && item?.name.length > 20)? (item?.name | slice:0:20)+'...' : (item?.name)}}
                    </div>
                </div>
                <div class="cc-right">
                    <div class="cc-percentage">{{item.percentage}}%</div>
                </div>
            </div>
        </div>
        <div class="cc-view-more" *ngIf="constContributionFilteredList.length > 0">
            <button (click)="openDialog()">View More</button>
        </div>
    </div>
</div>
<ng-template #costPopOver>
    <div class="mb-15-dt"> Waste Cost Contribution split at Line, SKU or BoM at the Factory
        level
        for the selected time period</div>

    <div class="tooltip-formula-dt">
        <div class="tooltip-left-dt">
            Cost Contribution =
        </div>
        <div class="tooltip-center-dt">
            <div class="tooltip-center-top-dt">
                total waste cost generated by the selected Line/SKU/BoM

            </div>
            <hr class="tooltip-center-middle-dt">
            <div class="tooltip-center-bottom-dt">
                total waste cost of the factory for the selected period
            </div>

        </div>
        <div class="tooltip-right-dt">
            * 100
        </div>
    </div>

</ng-template>
<ng-template #costPopOver1>
    <div class="mb-15"> Waste Cost Contribution split at SKU or BoM at the Line level for the selected time period</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost Contribution =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated by the selected SKU/BoM

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost of the Line for the selected period
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>